const DEVTOOLS_DOCK_THRESHOLD = 120;
const DEBUGGER_PAUSE_THRESHOLD_MS = 100;

let baselineWidthGap = 0;
let baselineHeightGap = 0;
let isBaselineCalibrated = false;

/** Record layout gaps at startup — DevTools is assumed closed. */
export const calibrateDevToolsBaseline = (): void => {
  baselineWidthGap = window.outerWidth - window.innerWidth;
  baselineHeightGap = window.outerHeight - window.innerHeight;
  isBaselineCalibrated = true;
};

/**
 * Detects a docked DevTools panel by measuring NEW gap since baseline.
 * Avoids false positives from browser chrome / Epic embed offsets.
 */
const isDevToolsOpenByDockedPanel = (): boolean => {
  if (!isBaselineCalibrated) {
    return false;
  }

  const widthDelta =
    window.outerWidth - window.innerWidth - baselineWidthGap;
  const heightDelta =
    window.outerHeight - window.innerHeight - baselineHeightGap;

  return widthDelta > DEVTOOLS_DOCK_THRESHOLD || heightDelta > DEVTOOLS_DOCK_THRESHOLD;
};

/**
 * DevTools pauses on `debugger` when the inspector is active.
 * Near-instant when DevTools is closed.
 */
const isDevToolsOpenByDebugger = (): boolean => {
  const start = performance.now();
  // eslint-disable-next-line no-debugger
  debugger;
  return performance.now() - start >= DEBUGGER_PAUSE_THRESHOLD_MS;
};

export const detectDevToolsOpen = (): boolean => {
  try {
    return isDevToolsOpenByDockedPanel() || isDevToolsOpenByDebugger();
  } catch {
    return isDevToolsOpenByDockedPanel();
  }
};

/** Enabled by default; set REACT_APP_BLOCK_DEVTOOLS=false to disable. */
export const isDevToolsBlockEnabled = (): boolean =>
  process.env.REACT_APP_BLOCK_DEVTOOLS !== "false";

const isBlockedShortcut = (event: KeyboardEvent): boolean => {
  const key = event.key.toLowerCase();

  if (key === "f12") {
    return true;
  }

  if (event.ctrlKey || event.metaKey) {
    if (event.shiftKey && ["i", "j", "c", "k"].includes(key)) {
      return true;
    }

    if (key === "u") {
      return true;
    }
  }

  if (event.metaKey && event.altKey && ["i", "j", "c"].includes(key)) {
    return true;
  }

  return false;
};

export const attachDevToolsBlockListeners = (
  onShortcutBlocked: (event: KeyboardEvent) => void
): (() => void) => {
  const handleKeyDown = (event: KeyboardEvent) => {
    if (!isBlockedShortcut(event)) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    onShortcutBlocked(event);
  };

  const handleContextMenu = (event: MouseEvent) => {
    event.preventDefault();
  };

  document.addEventListener("keydown", handleKeyDown, true);
  document.addEventListener("contextmenu", handleContextMenu);

  return () => {
    document.removeEventListener("keydown", handleKeyDown, true);
    document.removeEventListener("contextmenu", handleContextMenu);
  };
};
